import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthService } from 'src/app/shared/services/service';
import { apiUrl } from 'src/app/shared/services/api-url';
import {
  MockAnswerMap,
  MockAttempt,
  MockAvailability,
  MockDuration,
  MockHistoryItem,
  MockPaper,
  MockResult
} from './mock.models';
import { unwrapMockResult } from './mock-state';

@Injectable({
  providedIn: 'root'
})
export class MockService {
  constructor(private authService: AuthService) {}

  getProfile(): Observable<any> {
    return this.authService.ServerGet(apiUrl.user);
  }

  getAvailability(): Observable<MockAvailability> {
    return this.authService.ServerGet(apiUrl.mockAvailability).pipe(
      map(res => res as MockAvailability)
    );
  }

  listAttempts(): Observable<MockHistoryItem[]> {
    return this.authService.ServerGet(apiUrl.mockAttempts).pipe(
      map(res => (res || []) as MockHistoryItem[])
    );
  }

  createAttempt(paper: MockPaper, durationMinutes: MockDuration): Observable<MockAttempt> {
    return this.authService.ServerPost(apiUrl.mockAttempts, {
      paper: paper,
      duration_minutes: durationMinutes
    }).pipe(map(res => res as MockAttempt));
  }

  getAttempt(id: string | number): Observable<MockAttempt> {
    return this.authService.ServerGet(apiUrl.mockAttempts + id + '/').pipe(
      map(res => res as MockAttempt)
    );
  }

  submitAttempt(id: string | number, answers: MockAnswerMap): Observable<MockResult> {
    return this.authService.ServerPost(apiUrl.mockAttempts + id + '/submit/', {
      answers: answers
    }).pipe(map(res => unwrapMockResult(res) as MockResult));
  }
}
